import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'driver-login',
  templateUrl: 'driver-login.html',
  styleUrls: ['./header.component.less']
})
export class DriverLoginDialogComponent {
  hide = true;
  email = new FormControl('', [Validators.required, Validators.email]);

  getErrorMessage(): string {
    if (this.email.hasError('required')) return 'You must enter a value';
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }
}
